import { forwardRef } from "react";
import CardShell from "./CardShell";

const CoverCard = forwardRef(function CoverCard({ cover, contact }, ref) {
  const [first, ...rest] = cover.title.split(" ");
  return (
    <CardShell ref={ref} variant="cover" testId="cover-card">
      <header className="mc-head mc-head--center">
        <div className="mc-wordmark" data-testid="cover-card-wordmark">MEDAVITA</div>
        <div className="mc-cover-agent" data-testid="cover-card-agent">
          <b>{contact.salon || "Agent vânzări Medavita"}</b>
          {contact.whatsapp ? <span>Tel. {contact.whatsapp}</span> : <span className="mc-phone-blank">Tel.</span>}
        </div>
      </header>

      <div className="mc-cover-visual">
        {cover.image ? (
          <div className="mc-arch">
            <img src={cover.image} alt={cover.title} data-testid="cover-card-photo" />
          </div>
        ) : (
          <div className="mc-rings" data-testid="cover-card-ornament">
            <span className="mc-ring mc-ring--1" />
            <span className="mc-ring mc-ring--2" />
            <span className="mc-ring mc-ring--3" />
            <span className="mc-monogram">BE</span>
          </div>
        )}
      </div>

      <section className="mc-cover-text">
        <div className="mc-kicker mc-kicker--center">{cover.subtitle}</div>
        <h1 className={`mc-cover-title ${cover.title.length > 12 ? "mc-cover-title--long" : ""}`} data-testid="cover-card-title">
          {first} {rest.length > 0 && <em>{rest.join(" ")}</em>}
        </h1>
        <div className="mc-rule" />
        <p className="mc-cover-tagline">{cover.tagline}</p>
      </section>
    </CardShell>
  );
});

export default CoverCard;
